import { SchedulerStoreType } from "../../state/scheduler.store";
import { cancelAutobook } from "../../services/api/cancel.api";
import { ReasonType } from "@rooster/types";

export const cancelAutobookHelper = async ({
  availabilityId,
  actions,
  reason,
  comment
}: {
  availabilityId: string;
  actions: SchedulerStoreType["actions"];
  type: "autobook" | "pml";
  reason?: ReasonType;
  comment?: string;
}) => {
  if (availabilityId) {
    const result = await cancelAutobook({
      availabilityId,
      reason,
      comment
    });
    if (result === "OK") {
      actions.setUiState({
        currentStep: "scheduling_cancelled",
        currentView: "month"
      });
    } else {
      actions.setUiState({
        currentStep: "scheduling_failed",
        currentView: "month"
      });
    }
  }
};
